import { cloneDeep } from 'lodash';
import { getBehavior, trackConfig } from '@/framework';
import { Framework } from '@/framework/instance';
import { LayerType, ReferenceLine } from '@/version-types';
import { historyQuickResizeOperate } from '../type';

/**
 * 长画布舞台快速调整
 */
export class QuickResizeOperate extends Framework {
    /**
     * 写入操作历史记录
     *
     * @param originIndex - 原序号
     * @param oldHeight - 旧的高度
     * @param newHeight - 新的高度
     */
    write(
        originIndex: number,
        oldHeight: number,
        newHeight: number,
        oldReferenceLines: ReferenceLine[],
        newReferenceLines: ReferenceLine[],
    ) {
        const isRender = this.framework.checkStageIsRender(originIndex);
        if (!isRender) return this;
        this.framework.history.write({
            type: historyQuickResizeOperate,
            data: {
                originIndex,
                oldHeight,
                newHeight,
                oldReferenceLines,
                newReferenceLines,
            },
            trackFunc: trackConfig[LayerType.BACKGROUND_LAYER]?.resize,
        });
        return this;
    }

    /** 同步快速调整 */
    send(originIndex: number, oldHeight: number, newHeight: number, isStart: boolean, isEnd: boolean) {
        const isRender = this.framework.checkStageIsRender(originIndex);
        if (!isRender) return this;
        this.framework.history.realEdit.send(historyQuickResizeOperate, {
            originIndex,
            oldHeight,
            newHeight,
            isStart,
            isEnd,
        });
        return this;
    }

    /**
     * 快速调整长图高
     *
     * @param originIndex - 原序号
     * @param height - 高度
     */
    doResize(originIndex: number, height: number) {
        const isRender = this.framework.checkStageIsRender(originIndex);
        if (!isRender) return this;
        const backgroundLayer = cloneDeep(this.framework.getBackgroundLayer(originIndex));
        if (backgroundLayer) {
            getBehavior(this.framework.identity, backgroundLayer)?.adjustHeight?.(backgroundLayer, height);
            this.framework.flatLayersMap.set(backgroundLayer.id, { ...backgroundLayer });
        }
        this.framework.setRerender(originIndex);
        this.framework.rerender();
        // this.framework.updateExtraInfoSize(this.framework.convertOriginToStage(originIndex));
        return this;
    }
}
